import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface IEnableStopListJobCheckBox {
	toggleStopListJob: () => void;
	enableStopListJob: boolean;
}

const EnableStopListJobCheckBox: React.FC<IEnableStopListJobCheckBox> = ({ enableStopListJob, toggleStopListJob }) => {
	return (
		<Form.Item name="enableStopListJob">
			<Checkbox checked={enableStopListJob} onChange={toggleStopListJob}>
				<Text translationNameSpace="form" translationKey="enableStopListLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(EnableStopListJobCheckBox);
